//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"DimX",0,"Expression",0],[1,"DimY",0,"Expression",0],[0,"IsMoldCostAssembly",1,0],[0,"PointFrom",1,"Point",0],[0,"PointTo",1,"Point",0],[0,"RepositionMethod",1,0],[0,"RepositionType",1,0],[1,"RotateAngle",0,"Expression",0],[0,"RotatePoint",1,"Point",0],[1,"SelectInstance",0,"SelectNXObjectList",0]],[[["selectedCavity"],"AddCavity",{},1,0],[["copyOption"],"RepositionMove",{},1,0],[["type","copyOption"],"RepositionRotate",{},2,0],[["copyOption"],"RepositionPointToPoint",{},1,0],[[],"RepositionToOriginal",{},0,0],[[],"RemoveOperation",{},0,0],[["cavityComponent"],"AddACavityToMoveCavities",{},1,0],[[],"ClearMoveCavities",{},0,0],[["cavityComponent"],"AddACavityToCopyCavities",{},1,0],[[],"ClearCopyCavities",{},0,0]],[]];
SPLM.Tooling.LayoutRepositionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.LayoutRepositionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.LayoutRepositionBuilder.Method = Object.freeze({
    "Rotate" : "Rotate", "Transform" : "Transform", "PointToPoint" : "PointToPoint"});

SPLM.Tooling.LayoutRepositionBuilder.Type = Object.freeze({
    "Move" : "Move", "Copy" : "Copy"});

export default SPLM;